import { Label } from '@dealroadshow/uikit/core/components/Badge/Label';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { Link } from '@/Framework/Router/Next/Link';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from './sectorIndustry.scss';

interface ISectorIndustryProps {
  deal: IDealHeader,
}

const SectorIndustry = ({ deal }: ISectorIndustryProps) => (
  <div className={ styles.sectorIndustryCell }>
    <Tooltip
      content={ `${ deal.dealTypeObject.name }: ${ deal.dealTypeSubObject.name } ` }
      className={ styles.tooltip }
    >
      <Link
        to={ deal.sectorIndustryLink }
        onClick={ (event) => event.stopPropagation() }
        className={ styles.link }
        dataTest="dealRowSectorIndustryLink"
      >
        <Label
          className={ styles.label }
          backgroundColor={ deal.dealTypeObject.color }
        >
          { deal.dealTypeObject.abbreviation }
        </Label>
      </Link>
    </Tooltip>
  </div>
);

export default SectorIndustry;
